import siLK from '../../date-picker/locale/si_LK';
export default siLK;
